module.exports = __webpack_public_path__ + "static/img/home_our products_PU.a26a8001.jpg";